import { useCallback } from "react";

import { useSiteStatus } from "./App";
import { arrayBufferToBase64, base64ToArrayBuffer } from "xAppLib/helpers/conversion";

export const useEncryptString = () => {
	const fecry = useSiteStatus("fecry");

	const encryptString = useCallback(
		async str => {
			if (typeof fecry !== "string" || !fecry) {
				console.error("Fecry doesn't exists in site status.");
				return { error: "Fecry doesn't exists in site status." };
			}

			const [keyName, encodedPublicKey] = fecry.split(":");
			if (!keyName || !encodedPublicKey) {
				console.error("Fecry format is not correct.");
				return { error: "Fecry format is not correct." };
			}

			try {
				// Decode public key and remove header and footer
				let publicKey = atob(encodedPublicKey)
					.replace(/-----.*?-----/g, "")
					.replace(/\s/g, "");

				// convert buffer array
				publicKey = base64ToArrayBuffer(publicKey);

				// Create the crypto key object
				publicKey = await crypto.subtle.importKey(
					"spki",
					publicKey,
					{
						name: "RSA-OAEP",
						hash: "SHA-256",
					},
					false,
					["encrypt"],
				);

				let encrypted = new TextEncoder().encode(str);
				encrypted = await crypto.subtle.encrypt(
					{
						name: "RSA-OAEP",
					},
					publicKey,
					encrypted,
				);
				encrypted = arrayBufferToBase64(encrypted);
				// Convert array buffer to base64 string
				return {
					encrypted,
					encryptedWithKeyName: `${keyName}:${encrypted}`,
				};
			} catch (error) {
				console.error("Encrypt String failed:", error);
				return { error };
			}
		},
		[fecry],
	);

	return { encryptString };
};
